
export class PreSignedUrlUploadService {

  /**
   * Uploads file to a server using a pre-signed url
   * @param {PreSignedUrlGetter} urlGetter
   * @param {AbstractPreSignedUrlUploader} uploader
   * @param {AbstractFilenameSubmitter} filenameSubmitter
   * @return {Promise<any>}
   */
  async upload(urlGetter, uploader, filenameSubmitter) {
    const preSignedUrlData = await urlGetter.getPreSignedUrlData();

    uploader.preSignedUrlData = preSignedUrlData;
    const updatedPreSignedUrlData = await uploader.uploadToPreSignedUrl();

    filenameSubmitter.preSignedUrlData = updatedPreSignedUrlData || preSignedUrlData;
    const submitResult = await filenameSubmitter.submitFilenames();
    return updatedPreSignedUrlData || submitResult;
  }

}

export const preSignedUrlUploadService = new PreSignedUrlUploadService();
